import h from "./index.es472.js";
function i(e, n) {
  var t = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (t) return (t = t.call(e)).next.bind(t);
  if (Array.isArray(e) || (t = g(e)) || n) {
    t && (e = t);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function g(e, n) {
  if (e) {
    if (typeof e == "string") return p(e, n);
    var t = {}.toString.call(e).slice(8, -1);
    return t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set" ? Array.from(e) : t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? p(e, n) : void 0;
  }
}
function p(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var t = 0, r = Array(n); t < n; t++) r[t] = e[t];
  return r;
}
function C(e) {
  var n = e.sheets, t = e.images;
  return '<?xml version="1.0" ?><Types xmlns="http://schemas.openxmlformats.org/package/2006/content-types"><Default ContentType="application/xml" Extension="xml"/><Default ContentType="application/vnd.openxmlformats-package.relationships+xml" Extension="rels"/>' + n.map(function(r) {
    var o = r.id;
    return '<Override ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml" PartName="/xl/worksheets/sheet'.concat(o, '.xml"/>');
  }).join("") + n.map(function(r) {
    var o = r.id, a = r.images;
    return a ? '<Override ContentType="application/vnd.openxmlformats-officedocument.drawing+xml" PartName="/xl/drawings/drawing'.concat(o, '.xml"/>') : "";
  }).join("") + '<Override ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml" PartName="/xl/workbook.xml"/><Override ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml" PartName="/xl/sharedStrings.xml"/><Override ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml" PartName="/xl/styles.xml"/>' + T(t).map(function(r) {
    var o = r.fileExtension, a = r.contentType;
    return '<Default Extension="'.concat(o, '" ContentType="').concat(a, '"/>');
  }).join("") + "</Types>";
}
function T(e) {
  if (!e)
    return [];
  var n = [], t = function(s) {
    var c = h(s.contentType), v = n.find(function(y) {
      return y.fileExtension === c;
    });
    v || n.push({
      fileExtension: c,
      contentType: s.contentType
    });
  };
  if (Array.isArray(e[0]))
    for (var r = i(e), o; !(o = r()).done; )
      for (var a = o.value, f = i(a), l; !(l = f()).done; ) {
        var u = l.value;
        t(u);
      }
  else
    for (var d = i(e), m; !(m = d()).done; ) {
      var x = m.value;
      t(x);
    }
  return n;
}
export {
  C as default
};
//# sourceMappingURL=index.es428.js.map
